import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Modal, TextHeadline2, TextBody, Button } from 'blocket-ui'
import Heart from './Heart.svg.js'

const StyledModal = styled(Modal)`
  max-width: 480px;
  @media screen and (max-width: 767px) {
    border-radius: 10px;
    width: 90%;
    left: 50%;
    top: 50%;
    height: auto;
    transform: translate(-50%, -50%);
  }
`
const Wrapper = styled.div`
  padding: 24px 16px 16px 16px;
`
const StyledSvg = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 0 24px 0;
  @media screen and (max-height: 480px) {
    display: none;
  }
`
const StyledTitle = styled(TextHeadline2)`
  margin-bottom: 8px;
  text-align: center;
`
const StyledBodyText = styled(TextBody)`
  text-align: center;
`
const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 24px;
`
const StyledLink = styled.button`
  margin: 24px 0 16px 0;
  font-family: BlocketSans-Regular, Sans-Serif;
  font-size: 17px;
  line-height: 1.41;
  color: #4182c3;
  width: initial;
  cursor: pointer;
  &:hover {
    color: #679bcf;
    text-decoration-line: underline;
  }
  &:active {
    color: #34689c;
  }
`

const SaveErrorModal = ({ title, text, onClose, hrefToSaved, savedButtonText }) => {
  return (
    <StyledModal label={text} onClose={onClose} open>
      <Wrapper>
        <StyledSvg>
          <Heart height={96} width={96} />
        </StyledSvg>
        <StyledTitle>{title}&nbsp;</StyledTitle>
        <StyledBodyText>{text}</StyledBodyText>
        <ButtonContainer>
          <Button
            data-testid="save-error-modal-link"
            type="secondary"
            onClick={onClose}
            href={hrefToSaved}
            target="_blank"
            rel="noopener noreferrer"
          >
            {savedButtonText}
          </Button>
          <StyledLink tabIndex="0" role="button" onClick={onClose}>
            Stäng
          </StyledLink>
        </ButtonContainer>
      </Wrapper>
    </StyledModal>
  )
}

SaveErrorModal.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  savedButtonText: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  hrefToSaved: PropTypes.string.isRequired,
}

export default SaveErrorModal
